import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../ui/alert-dialog';
import { P } from '../ui/typography';

interface DeleteAvailabilityAlertProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isAvailability: boolean;
}

export function DeleteAvailabilityAlert({
  open,
  onOpenChange,
  onConfirm,
  isAvailability
}: DeleteAvailabilityAlertProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete {isAvailability ? 'Availability' : 'Unavailability'}</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to delete this {isAvailability ? 'availability' : 'unavailability'} record? This action cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onPress={() => onOpenChange(false)}>
            <P className="text-white">Cancel</P>
          </AlertDialogAction>
          <AlertDialogAction
            className="bg-red-500 hover:bg-red-600"
            onPress={() => {
              onConfirm();
              onOpenChange(false);
            }}>
            <P className="text-black">Delete</P>
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
} 